export default class AssetViewmodel {
    public id: number = 0;
    public plantItemNumber: string = '';
    public clientId: number = 0;
    public client: string = '';
    public plantId: number = 0;
    public plant: string = '';
    public assetType: number = 0;
}